import { Box } from 'shared/mui/Box';
import { Tooltip } from 'shared/mui/Tooltip';
import { BooleanInput } from 'shared/react-admin/Inputs';

type Props = {
  disabled?: boolean;
  disabledReason?: string;
};

export const CommissionsZeroedInput: React.FC<Props> = ({
  disabled = false,
  disabledReason = '',
}) => {
  return (
    <Tooltip arrow title={disabled ? disabledReason : ''}>
      <Box>
        <BooleanInput
          defaultValue={false}
          disabled={disabled}
          label="Нулевая комиссия"
          size="small"
          source="rate.zeroed"
          variant="outlined"
        />
      </Box>
    </Tooltip>
  );
};
